import type { ActionType } from './types/marketingFlow'

const trackedLinkPattern = /\{\{\s*(reviewLink|customLink)\b/i

export const CLICK_TRIGGERED_ACTION_TYPES: readonly ActionType[] = [
  'REWARD',
  'BONUS_POINTS',
  'BONUS_MULTIPLIER',
  'CALL_EXTERNAL_API'
]

export const isClickTriggeredAction = (actionType: ActionType): boolean =>
  CLICK_TRIGGERED_ACTION_TYPES.includes(actionType)

export const messageContainsTrackedLink = (message?: string | null): boolean =>
  typeof message === 'string' && trackedLinkPattern.test(message)

export const valueContainsTrackedLink = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return messageContainsTrackedLink(value)
  }

  if (value === null || value === undefined) {
    return false
  }

  return messageContainsTrackedLink(JSON.stringify(value))
}
